import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SiteSettingsService } from '../../shared/services/site-settings/site-settings/site-settings.service';
import { SiteSetting } from '../../shared/services/site-settings/site-settings/site-setting';
import { IconComponent } from '../../controls/icons/icon/icon.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-server-error',
    templateUrl: './server-error.component.html',
    styleUrls: ['./server-error.component.scss'],
    imports: [
    IconComponent,
    AsyncPipe
],
})
export class ServerErrorComponent implements OnInit {
	private siteSettingService = inject(SiteSettingsService);

	helpLinkUrl$: Observable<string>;


	ngOnInit(): void {
		this.helpLinkUrl$ = this.siteSettingService.getSettingValue(SiteSetting.HelpDeskUrl);
	}
}
